import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link, useParams, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { fetchData, deleteData, activateData, SyncData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import RateReviewIcon from '@mui/icons-material/RateReview';
import EditNoteIcon from '@mui/icons-material/EditNote';
import InvoicePrint from '../Invoice/Estimate';
import NongstBillPrint from '../Invoice/Bill';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';

function EditedSaleIndex() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const { id } = useParams(); // trip id 
    const { isAuthenticated, companyId, userId, permissions, logout, token } = useAuth();
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [isFocused, setIsFocused] = useState(false);
    const [tid, setTripId] = useState(null);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('TripInvoiceApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);

            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };


    const [searchQuery, setSearchQuery] = useState('');

    // Handle search input
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    // Filter data based on search query
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const handleTripChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);
        setData([]); // Clear the existing data with an empty array

        try {
            const response = await fetchData('TripInvoiceApi', `/EditedSaleList/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
                setTripId(selectedOption.value);
                console.log(response);
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };

    const [showModal, setShowModal] = useState(false);
    const [selectedSaleItems, setSelectedSaleItems] = useState([]);
    const [selectedSaleHeader, setSelectedSaleHeader] = useState(null);

    const handleSaleClick = async (saleId) => {
        try {
            const response = await fetchData('SaleApi', `/LedgerSaleDetails/${saleId}`, token);
            if (response.responseCode === '1111') {
                setSelectedSaleHeader(response.response_data.sale || null);
                setSelectedSaleItems(response.response_data.saleDetails || []);
                setShowModal(true);
            }
        } catch (error) {
            console.error('Error fetching Sale Items:', error);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedSaleItems([]);
        setSelectedSaleHeader(null);
    };

    const handleSaleOrderPrint = async (SaleOrderid) => {
        try {
            // Fetch data
            const response = await fetchData('SaleOrderApi', `/SaleorderPrint/${SaleOrderid}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                labelData[0].SaleOrderPrint.IsGST === true ? (
                    <InvoicePrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ) : (
                    <NongstBillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ),
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();

            try {
                await SyncData('SaleOrderApi', `${SaleOrderid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className='w-full mb-2 flex'></div>
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bold', textTransform: 'uppercase' }}>Sale List</h6>

                {/* Search field */}
                <div className="w-1/4 mr-2" style={{ marginTop: '-10px' }}>

                    <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                        Trip
                    </label>
                    <Select
                        value={selectedTrip}
                        onChange={handleTripChange}
                        options={tripOptions}
                        placeholder="Select Trip"
                        isSearchable
                    />
                </div>

            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#243642' }}>
                            <TableRow>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '50px' }}>Order.No</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Cus.Order No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '7px', color: 'whitesmoke', textAlign: 'left' }}>Customer</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Contact No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>OrderDate</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>No:Of Product</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>Action</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#FEF9F2' }}>
                            {filteredData.length > 0 ? (
                                filteredData.map((item) => (
                                    <TableRow key={item.id} className="size">
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: 'black',
                                                padding: '2px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {item.routeSequenceNo}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: 'black',
                                                padding: '2px',
                                                textAlign: 'left',
                                            }}
                                        >
                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleSaleClick(item.id);
                                                }}
                                                className="tooltip-link"
                                            >
                                                <h6
                                                    className="psheading linkcolor"
                                                    style={{
                                                        fontFamily: 'Times New Roman',
                                                        color: 'black',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {`${item.customerName || ''}  ${item.addressLine1 || ''} ${item.customerCode || ''}`.trim()}
                                                </h6>
                                            </a>
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',//
                                                color: 'black',
                                                padding: '2px',

                                            }}
                                        >
                                            {item.customerContact}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: 'orangered',

                                                padding: '2px',
                                            }}
                                        >
                                            {item.invoiceDate && new Date(item.invoiceDate).toLocaleDateString('en-GB')}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: 'black',
                                                padding: '2px',
                                                textAlign: 'center',
                                                height: '35px',
                                            }}
                                        >
                                            <Tooltip title="Generate the Sale Bill">
                                                <Button
                                                    onClick={() => handleSaleOrderPrint(item.saleOrderId)}
                                                    style={{
                                                        backgroundColor: 'orange',
                                                        color: 'whitesmoke',
                                                        height: '25px',
                                                    }}
                                                >
                                                    Print Invoice
                                                </Button>
                                            </Tooltip>
                                        </TableCell>

                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7} sx={{ textAlign: 'center' }}>
                                        No data available
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>

            <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                <div className="fixed inset-0 flex items-start justify-center z-10 ">
                    <div
                        className="bg-green-100 p-6 rounded-lg shadow-lg"
                        style={{ width: '1200px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}
                    >
                        <div className="flex justify-end mt-2">
                            <button
                                className="close-button md:static md:mr-2"
                                onClick={closeModal}
                                style={{ marginTop: '-20px', color: 'black' }}
                            >
                                <Tooltip title="Close">
                                    <FaTimes />
                                </Tooltip>
                            </button>
                        </div>
                        <h6
                            style={{
                                fontFamily: 'Times New Roman',
                                textAlign: 'center',
                                color: '#347928',
                                fontWeight: 'bolder',
                            }}
                        >
                            SALE ITEMS
                        </h6>

                        {selectedSaleHeader && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0', fontSize: '14px' }}>
                                <span>
                                    <strong>Customer: </strong>
                                    {selectedSaleHeader.customerName || ''}
                                </span>
                                <span>
                                    <strong>Invoice No: </strong>
                                    {selectedSaleHeader.prefix || ''}
                                    {selectedSaleHeader.invoiceNo || selectedSaleHeader.orderNumber || ''}
                                </span>
                                <span>
                                    <strong>Date: </strong>
                                    {(() => {
                                        const d =
                                            selectedSaleHeader.invoiceDate ||
                                            selectedSaleHeader.orderDate ||
                                            selectedSaleHeader.billDate ||
                                            selectedSaleHeader.saleDate;
                                        return d ? new Date(d).toLocaleDateString('en-GB') : '';
                                    })()}
                                </span>
                            </div>
                        )}

                        <div className="used-items-container">
                            <TableContainer component={Paper} style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
                                <table className="table" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '5%', fontSize: '14px' }}>Sl.No</th>
                                            <th style={{ width: '20%', fontSize: '14px', textAlign: 'left' }}>Name</th>
                                            <th style={{ width: '7%', fontSize: '14px' }}>Qty
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(No.Pieces)</p>
                                            </th>
                                            <th style={{ width: '8%', fontSize: '14px' }}>T.Qty
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Kgs)</p>
                                            </th>
                                            <th style={{ width: '6%', fontSize: '14px' }}>Bundle</th>
                                            <th style={{ width: '6%', fontSize: '14px' }}>Pieces</th>
                                            <th style={{ width: '10%', fontSize: '14px' }}>Rate
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Per Kg)</p>
                                            </th>
                                            <th style={{ width: '8%', fontSize: '14px' }}>Discount</th>
                                            <th style={{ width: '10%', fontSize: '14px' }}>Rate
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(After Discount)</p>
                                            </th>
                                            <th style={{ width: '10%', fontSize: '14px' }}>Taxable Amt</th>
                                            <th style={{ width: '5%', fontSize: '14px' }}>GST%</th>
                                            <th style={{ width: '9%', fontSize: '14px' }}>GST Amt</th>
                                            <th style={{ width: '10%', fontSize: '14px' }}>Total Amt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedSaleItems && selectedSaleItems.length > 0 ? (
                                            selectedSaleItems.map((it, index) => (
                                                <tr key={index}>
                                                    <td className="px-4 py-2 border-r text-center" style={{ fontSize: '13px' }}>{index + 1}</td>
                                                    <td className="px-4 py-2 border-r" style={{ fontSize: '13px', color: 'blueviolet' }}>{it.itemName || it.item}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{it.quantity || 0}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{it.totalQty || 0}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{it.bundle || 0}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{it.pieces || 0}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{(it.ratePerKg ?? 0).toFixed(2)}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{(it.discountPerPiece ?? 0)}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{(it.rateAfterDiscount ?? 0).toFixed(2)}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{(it.taxableAmt ?? 0).toFixed(2)}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{it.gstRate ?? 0}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{(it.gstAmt ?? 0).toFixed(2)}</td>
                                                    <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{(it.netAmount ?? 0).toFixed(2)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={13} style={{ textAlign: 'center', padding: '10px' }}>
                                                    No items to display
                                                </td>
                                            </tr>
                                        )}
                                        {selectedSaleItems && selectedSaleItems.length > 0 && (
                                            <tr style={{ backgroundColor: 'lightblue', fontWeight: 'bold' }}>
                                                <td className="px-4 py-2 border-r text-left" colSpan={2}>TOTAL</td>
                                                <td className="px-4 py-2 border-r text-right">
                                                    {selectedSaleItems.reduce((s, it) => s + (Number(it.quantity) || 0), 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right">
                                                    {selectedSaleItems.reduce((s, it) => s + (Number(it.totalQty) || 0), 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right">
                                                    {selectedSaleItems.reduce((s, it) => s + (Number(it.bundle) || 0), 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right">
                                                    {selectedSaleItems.reduce((s, it) => s + (Number(it.pieces) || 0), 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r"></td>
                                                <td className="px-4 py-2 border-r text-right">
                                                    {selectedSaleItems.reduce((s, it) => s + (Number(it.discountPerPiece) || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r"></td>
                                                <td className="px-4 py-2 border-r text-right">
                                                    {selectedSaleItems.reduce((s, it) => s + (Number(it.taxableAmt) || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r"></td>
                                                <td className="px-4 py-2 border-r text-right">
                                                    {selectedSaleItems.reduce((s, it) => s + (Number(it.gstAmt) || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right">
                                                    {selectedSaleItems.reduce((s, it) => s + (Number(it.netAmount) || 0), 0).toFixed(2)}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </Modal>

        </div>
    );
}
export default EditedSaleIndex;

